"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = Component;
const React = __importStar(require("react"));
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const LocalElements = __importStar(require("./elements"));
const Actions = __importStar(require("./actions"));
const NevadaTable = __importStar(require("../nevada-shared/nevada-table"));
const Contexts = __importStar(require("@genesys/client-core/lib/contexts"));
const Exporter = __importStar(require("@genesys/client-core/lib/exporter"));
const DateHelper = __importStar(require("@genesys/shared/lib/date-helper"));
const SharedElements = __importStar(require("../nevada-shared/elements"));
const Importer = __importStar(require("@genesys/client-core/lib/data-upload"));
const SharedTools = __importStar(require("../nevada-shared/functions"));
const moment_1 = __importDefault(require("moment"));
const run_request_1 = require("./run-request");
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
function Component(props) {
    return (React.createElement("div", null,
        React.createElement(Elements.FlexContainerRowWithPadding, { center: false },
            React.createElement(InputView, Object.assign({}, props)),
            React.createElement(DataControlView, Object.assign({}, props)),
            React.createElement(ResultView, Object.assign({}, props)))));
}
function InputView(props) {
    return (React.createElement(Elements.FlexContainerRow, { center: false },
        React.createElement(Elements.FlexContainerStack, { center: false, centerVertically: false },
            React.createElement(InputRows, { running: props.running, dispatch: props.dispatch, inputRows: props.inputRows }),
            React.createElement(Elements.FlexContainerRow, { center: false },
                React.createElement(Elements.AddButton, { onClick: () => props.dispatch(Actions.addTestRow()), disabled: props.running })))));
}
function ResultView(props) {
    if (!props.showResults) {
        return null;
    }
    const { authorization, graphqlEndpoint } = React.useContext(Contexts.clientConfigContext);
    const { locale } = React.useContext(Contexts.UserProfileContext);
    const { getAmountFormat } = React.useContext(Contexts.ScreenAmountProfileContext);
    const dateFormatter = (date) => DateHelper.getDateString(date, locale);
    return (React.createElement(React.Fragment, null,
        React.createElement(NevadaTable.TableContainer, null, props.systemTestRows.map(x => {
            return (React.createElement(NevadaTable.TableRow, { internalId: x.id, result: x.result, runRequest: () => (0, run_request_1.runRequests)(x, graphqlEndpoint, authorization, getAmountFormat, system => props.dispatch(Actions.updateTestSystem(system))), referenceSystemName: x.name, referenceSystemNo: x.referenceNo, referenceSystemRev: x.referenceRev, testSystemNo: x.testNo, testSystemRev: x.testRev, rowType: "system-compare", status: x.status, systemType: x.systemType, systemIsExpanded: x.expanded, key: x.id, systemRowIsOk: x.systemRowIsOk, toggleNode: (testId, path) => props.dispatch(Actions.toggleNode(testId, path)), toggleSystem: () => props.dispatch(Actions.updateTestSystem(Object.assign(Object.assign({}, x), { expanded: !x.expanded }))) }));
        })),
        React.createElement(Elements.FlexContainerStack, { center: false, justifyContent: "start" },
            React.createElement(Exporter.XlsxSingleSheetExport, { filename: "SystemCompare" + dateFormatter((0, moment_1.default)()), data: props.running ? [] : exportDifferences(props.systemTestRows) }, onClick => (React.createElement(Elements.StandardButton, { onClick: onClick, disabled: props.running }, "Export differences"))))));
}
function InputRows({ running, inputRows, dispatch }) {
    return (React.createElement(React.Fragment, null, inputRows.map((x, ix) => (React.createElement("div", null,
        React.createElement(SharedElements.InputRowContainer, { key: x.id },
            React.createElement(LocalElements.InputEditText, { disabled: running, width: "150px", value: x.referenceGenesysNo, onChange: e => dispatch(Actions.setReferenceGenesysNo(e.target.value, ix)), placeholder: "Reference Genesys No" }),
            React.createElement(LocalElements.InputEditText, { disabled: running, width: "150px", value: x.testGenesysNo, onChange: e => dispatch(Actions.setTestGenesysNo(e.target.value, ix)), placeholder: "Test Genesys No" }),
            React.createElement(Elements.DeleteButton, { onClick: () => dispatch(Actions.deleteTestRow(ix)), disabled: inputRows.length <= 1 || running })),
        !!x.errorMessage.length && (React.createElement(LocalElements.WarningContainer, null, x.errorMessage.map(message => (React.createElement("li", null,
            React.createElement("img", { src: `/assets/images/component-messages/warning.png` }),
            React.createElement("span", null, message)))))))))));
}
function DataControlView(props) {
    const hasDupes = false;
    return (React.createElement(SharedElements.DataControlContainer, null,
        React.createElement(Elements.FlexContainerRow, { style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between"
            } },
            React.createElement("span", null, "Size: "),
            React.createElement(Elements.InputEditText, { value: props.runningSize, disabled: props.running, style: {
                    width: "40px"
                }, width: "40px", type: "number", min: "0", onChange: e => props.dispatch(Actions.setRunningSize(parseInt(e.target.value, 10))), placeholder: "Running size" })),
        React.createElement(Importer.SimpleDataUploadContainer, { onParsed: data => {
                props.dispatch(Actions.importSystems(data));
            } }, upload => (React.createElement(Elements.StandardButton, { onClick: upload, disabled: props.running }, "Import"))),
        React.createElement(Elements.StandardButton, { onClick: () => props.dispatch(Actions.runTest()), disabled: props.running || props.runningSize <= 0 || hasDupes }, "Run tests")));
}
function excelColumns() {
    return [
        { columnName: "name", displayName: "Name" },
        { columnName: "tags", displayName: "" },
        { columnName: "unit", displayName: "Unit" },
        { columnName: "ref", displayName: "Reference" },
        { columnName: "test", displayName: "Test" },
        { columnName: "diff", displayName: "DIff" }
    ];
}
function getSystemHeaderValues(col, s) {
    switch (col) {
        case "name": {
            return s.name;
        }
        case "unit": {
            return "";
        }
        case "tags": {
            return s.systemRowIsOk
                ? "OK"
                : s.result.type === "error"
                    ? s.result.errorText
                    : "";
        }
        case "test": {
            return s.testNo ? s.testNo + "-" + s.testRev : "";
        }
        case "ref": {
            return s.referenceNo + "-" + s.referenceRev;
        }
        case "diff": {
            return "";
        }
        default:
            return (0, ts_exhaustive_check_1.exhaustiveCheck)(col);
    }
}
function exportDifferences(systems) {
    const columns = excelColumns();
    return systems
        .map(s => {
        const header = columns.map(x => getSystemHeaderValues(x.columnName, s));
        const result = s.result;
        if (result.type === "error") {
            return [header];
        }
        else {
            return [
                ...[...[header]],
                ...SharedTools.compareResult(result, columns, "")
            ];
        }
    })
        .reduce((a, b) => [...a, ...b], [columns.map(x => x.displayName)]);
}
//# sourceMappingURL=container-component.js.map